<template>
  <div>
    <div class="white-container" :key="$store.getters['resource/currentResource'].key">
      <event-view @save="saveEvent" :prefillParams="prefillParams" v-if="prefillParams"/>
    </div>
  </div>
</template>

<script>
  import EventView from "./EventView.vue";

  export default {
    components: {
      EventView
    },
    middleware: 'auth',
    name: 'EventCreation',
    data () {
      return {
        prefillParams: null
      }
    },
    computed: {
      id () {
        return this.$route.params.id || ''
      }
    },
    mounted () {
      if(!this.id){
        this.$router.push({path: '/actions'})
      } else {
        this.getData(`events/handlers/${this.id}`, null, true).then(response => {
          if (response.data) {
            this.prefillParams = response.data
          }
        })
      }
    },
    methods: {
      saveEvent(params) {
        this.putData(`events/handlers/${this.id}`, params, '/actions');
      }
    }
  }
</script>